import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
//my components
import { FirebaseAuthComponent } from '../shared/firebase-auth/firebase-auth.component';
import { MessagesService } from './../shared/services/messages/message.service';





@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

  public error = null;
  public matcher = new ErrorStateMatcher();

  formLogin: FormGroup;

  constructor(private firebaseAuth: FirebaseAuthComponent,
              private fb: FormBuilder,
              private messageService: MessagesService,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void {
    this.formLogin = this.fb.group({
      email: [undefined, [
        Validators.required,
        Validators.email
      ]],
      password: [undefined, Validators.required],
      rememberMe: [undefined]
    });
    this.rememberMeRead();
    this.firebaseAuth.getUser()
    .subscribe(user => {
      console.log('el usuario en login es ', user);
      if (user){
        this.router.navigate([`/profile/${user.uid}`, { from: 'login' }]);
        // this.firebaseAuth.logout();
      }
    });
  }

  rememberMeSave(): void {
    if (this.formLogin.get('rememberMe').value) {
      const email = this.formLogin.get('email').value;
      const password = btoa(this.formLogin.get('password').value);
      localStorage.setItem('emailPlaybots', email);
      localStorage.setItem('passwordPlaybots', password);
      localStorage.setItem('rememberMePlaybots', btoa(this.formLogin.get('rememberMe').value));
    } else {
      localStorage.removeItem('emailPlaybots');
      localStorage.removeItem('passwordPlaybots');
      localStorage.removeItem('rememberMePlaybots');
    }
  }

  rememberMeRead(): void {
    const email = localStorage.getItem('emailPlaybots');
    const password = localStorage.getItem('passwordPlaybots');
    const rememberMe = localStorage.getItem('rememberMePlaybots');
    this.formLogin.get('email').setValue(email);
    this.formLogin.get('password').setValue(password ? atob(password) : '');
    this.formLogin.get('rememberMe').setValue(rememberMe);
  }

  login(): void {
    if (this.formLogin.valid) {
      const email = this.formLogin.get('email').value;
      const password = this.formLogin.get('password').value;

      this.rememberMeSave();
      this.firebaseAuth.login(email, btoa(password))
      .catch(error => this.messageService.openAlertDialog(error, 'Error al iniciar sesión'));
    }
  }
}
